import angular, { IOnInit } from "angular";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../../records/grids/controller";
import {
  IGridSettings,
  NullGridSettings,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import { MachineConfigurationView } from "../../models/machineConfiguration";
import { ConversionModalOptions } from "./service";

export class ConversionModalComponentController implements IOnInit {
  static $inject = [ColumnDefinitionServiceName];

  /* bindings */
  readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  readonly resolve!: { config: ConversionModalOptions };
  config!: ConversionModalOptions;
  /* end bindings */

  readonly additionalColumns: ColDef[];
  readonly gridSettings: IGridSettings = new NullGridSettings();
  readonly defaultQuery: IQuery = {
    CurrentConfiguration: true,
  };

  constructor(columnDefinitionService: ColumnDefinitionService) {
    this.additionalColumns = [
      columnDefinitionService.getCommandColDef({
        headerName: "select",
        iconClass: "fa fa-plus-circle text-primary",
        name: "select",
        width: 20,
      }),
    ];
    this.setModalWidth("950px");
  }

  $onInit(): void {
    this.config = this.resolve.config;
  }

  onItemCommand(args: IRowCommandEventArgs<MachineConfigurationView>) {
    switch (args.commandName) {
      case "select":
        this.modalInstance.close({
          machineId: args.data.MachineId,
          machineConfigurationId: args.data.Id,
        });
    }
  }
  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  newConversion() {
    this.modalInstance.close({
      machineId: undefined,
      machineConfigurationId: undefined,
    });
  }

  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
}
